import React from "react";
import { Shield } from "lucide-react";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

export default function Privacy() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Privacy"
        title="What the app"
        highlight="stores."
        description="Device readings, the profile fields the account needs, and a Firebase login."
      />

      <PageSection variant="content">
        <div className="mx-auto max-w-5xl grid gap-6">
          <Card className="shadow-soft">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Shield className="h-5 w-5 text-accent" />
                What we store
              </CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground leading-relaxed space-y-3">
              <p>The app stores soil moisture, air temperature, and humidity, plus the device name, whether it has been seen recently, alerts, and the profile fields needed to run the account.</p>
              <p>Login is handled by Firebase Authentication.</p>
            </CardContent>
          </Card>

          <div className="grid md:grid-cols-2 gap-6">
            <Card className="shadow-soft">
              <CardHeader>
                <CardTitle>Access control</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground leading-relaxed space-y-3">
                <p>Dashboard pages require sign-in. A device is stored on the account that added it.</p>
              </CardContent>
            </Card>

            <Card className="shadow-soft">
              <CardHeader>
                <CardTitle>Retention & deletion</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground leading-relaxed space-y-3">
                <p>You can download history as a CSV and remove a device from the app.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </PageSection>
    </PageShell>
  );
}

